import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const productDetailsStyle = StyleSheet.create({
    container: {
        flex: 1
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    cardContainer: {
        elevation: 0, borderColor: 'transparent', borderRadius: 7, flex: 1
    },
    taxContainer: {
        elevation: 0, borderColor: 'transparent', borderRadius: 7, paddingVertical: 10, marginBottom: 10
    },
    productView: {
        flex: 1, flexDirection: 'row'
    },
    imageView: {
        marginLeft: 12
    },
    detailsView: {
        marginLeft: 25
    },
    contentView: {
        flexDirection: 'row', marginTop: 8
    },
    checkboxView: {
        flexDirection: 'row', marginLeft: -20
    },
    packingView: {
        borderWidth: 0.5, padding: 10, borderColor: appColors.lightGrey, marginTop: 10, borderRadius: 5
    },
    cartStyle: {
        borderWidth: 0.3, borderColor: appColors.primary, marginLeft: 20, height: 36, borderRadius: 3
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize, fontFamily: appFonts.medium, fontWeight: undefined, color: appColors.grey, marginTop: 10, marginLeft: -3
    },
    inputStyle: {
        fontSize: fontSize.mediumFontSize, color: appColors.lightDark, fontFamily: appFonts.medium
    },
    inputContainerStyle: {
        borderColor: appColors.borderColor, height: 53, marginLeft: -3, marginBottom: -20
    },
    gstView: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    buttonStyle: {
        borderRadius: 7,
        paddingHorizontal: 15,
        backgroundColor: appColors?.primary
    },
    titleStyle: {
        color: appColors.light,
        fontSize: fontSize.smallHeaderFontSize,
        fontFamily: appFonts.bold,
    },
    buttonView: {
        alignItems: 'flex-end', flex: 1, alignSelf: 'center'
    },
    badgeStyle: {
        borderRadius: 8, marginLeft: 7
    },
    textStyle: {
        fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, paddingHorizontal: 10, textAlign: 'center'
    },
    offerView: {
        flexDirection: 'row', flex: 1, alignItems: 'center'
    },
    cardView: {
        flexDirection: 'row'
    },
    imageStyle: {
        marginTop: 15
    },
    productNameStyle: {
        marginTop: 10
    },
    priceStyle: {
        marginLeft: 20
    },
    variantImageView: {
        marginLeft: 45
    },
    variantImageStyle: {
        marginTop: 20
    },
    addtoCartView: {
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: appColors.lightGrey,
        borderWidth: 0.5,
        borderRadius: 3
    },
    iconView: {
        padding: 7
    },
    countTextView: {
        padding: 5
    },
    countTextStyle: {
        paddingHorizontal: 7
    },
    addToCartBtnStyle: {
        paddingHorizontal: 10, marginVertical: 8
    },
    offerTextStyle: {
        marginLeft: 13, marginTop: 15
    },
    plusIconStyle: {
        alignSelf: 'center',
        marginHorizontal: 5
    },
    discountView: {
        marginLeft: 15,
        gap: 5
    },
    notesStyle: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        fontWeight: undefined,
        color: appColors.labelColor,
        marginHorizontal: 10,
        marginTop: 10
    },
    textInputStyle: {
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.medium,
        fontWeight: undefined,
        color: appColors.lightDark,
        borderColor: appColors.borderColor,
        borderWidth: 1,
        marginHorizontal: 11,
        marginRight: 15,
        borderRadius: 5,
        marginTop: 5,
        height: 65,
        marginBottom: 5
    },
    taxStyle: {
        marginLeft: 12
    },
    switchStyle: {
        marginRight: 12
    }
})